import React from "react"
import CustomSkeleton from "../../../atoms/Skeleton"
import Square from "../../../shapes/Square"

const ProductGridItemSkeleton = () => {
  return (
    <div>
      <div className="flex items-center justify-center">
        <div className="w-1/2 mb-2">
          <Square>
            <CustomSkeleton variant="circle" width="100%" height="100%" />
          </Square>
        </div>
      </div>
      <div className="mb-2">
        <CustomSkeleton variant="text" />
      </div>
      <div className="mb-4">
        <CustomSkeleton variant="text" />
      </div>
      <CustomSkeleton variant="text" />
    </div>
  )
}

export default ProductGridItemSkeleton
